<template>
    <div style="display:flex;  height: 100%; ">
        <v-row style="margin: 0px; height: 100%; align-self: center;">
            <v-col class="tableauCalepinage colsCalepinage" cols="3">
                <v-data-table class="tableCalepinage" :items="rampants" :headers="headerRampants" :items-per-page="-1"
                    fixed-header hide-default-footer>
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>{{ $t('_rampants_') }}</v-toolbar-title>
                        </v-toolbar>
                    </template>
                </v-data-table>
                <v-data-table class="tableCalepinage" :items="historiqueOnduleurs" :headers="headerOnduleurs"
                    :items-per-page="-1" fixed-header hide-default-footer>
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>{{ $t('_onduleurs_') }}</v-toolbar-title>
                        </v-toolbar>
                    </template>
                </v-data-table>
            </v-col>
            <v-col class="colsCalepinage" cols="3">
                <div class="champs">
                    <!-- <div class="ligne"> -->
                    <div class="nom">{{ $t("_nom_du_point_de_mesure_") }}</div>
                    <!-- </div> -->
                    <v-text-field label="" outlined class="inputField" v-model="reponse.nom.value"></v-text-field>
                </div>


                <div class="ligne">
                    <div class="nom">{{ $t('_onduleurs_') }}</div>
                </div>
                <div class="groupe">
                    <div class="block">
                        <div class="champs">
                            <div class="nom">{{ $t('_nom_') }} (*)</div>

                            <select class="createSelect" v-model="reponse.idOnduleur.value">
                                <option disabled value=""> </option>
                                <option v-for="(inv, index) in historiqueOnduleurs" :value="inv.id" :key=index> {{
                                    inv.id
                                    }} - {{ inv.nom
                                    }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="block">
                        <div class="champs">
                            <div class="nom">{{ $t("_entree_DC_") }} (*)</div>

                            <select :disabled="reponse.idOnduleur.value === reponseVide.idOnduleur.value"
                                class="createSelect" v-model="reponse.entreeDC.value">
                                <option disabled value=""> </option>
                                <option v-for="i in findNbMPPT()"
                                    :value="findNameFromId(reponse.idOnduleur.value) + '.' + i" :key=i>
                                    {{ findNameFromId(reponse.idOnduleur.value) }}.{{ i }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="champs">
                    <!-- <div class="ligne"> -->
                    <div class="nom">{{ $t('_nom_rampant_') }} (*)</div>
                    <!-- </div> -->
                    <select class="createSelect" v-model="reponse.idRampant.value">
                        <option disabled value=""> </option>
                        <option v-for="(rampant, index) in rampants" :value="rampant.id" :key=index>
                            {{ rampant.id
                            }} - {{ rampant.nomRampant }}
                        </option>
                    </select>
                </div>

                <div class="ligne">
                    <div class="nom">{{ $t('_modules_') }}</div>
                </div>

                <div class="groupe">
                    <div class="block">
                        <div class="champs">
                            <div class="nom">{{ $t("_nb_de_chaines_") }} (*)</div>
                            <v-text-field label="" outlined class="inputField" v-model="reponse.nbChaine.value"
                                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"></v-text-field>
                        </div>
                    </div>
                    <div class="block">

                        <div class="champs">
                            <div class="nom">{{ $t("_nb_de_modules_") }} (*)</div>
                            <v-text-field label="" outlined class="inputField" v-model="reponse.nbModule.value"
                                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"></v-text-field>
                        </div>
                    </div>
                </div>

                <div class="groupe">
                    <div class="groupe block">
                        <div class="block champs">
                            <div class="nom">INIT {{ $t("_nb_de_chaines_") }}</div>
                            <v-text-field label="" outlined class="inputField" v-model="reponse.initNbChaine.value"
                                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"></v-text-field>
                        </div>
                        <div class="block champs">
                            <div class="nom">INIT {{ $t("_nb_de_modules_") }}</div>

                            <v-text-field label="" outlined class="inputField" v-model="reponse.initNbModule.value"
                                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"></v-text-field>
                        </div>
                    </div>

                    <div class="block champs">
                        <div class="nom">{{ $t("_chaine_uniforme_") }} (*)</div>

                        <select class="createSelect" v-model="reponse.chaineUniforme.value">
                            <option disabled value=""> </option>
                            <option value="oui"> {{ $t('_oui_') }} </option>
                            <option value="non"> {{ $t('_non_') }} </option>
                        </select>
                    </div>
                </div>

                <div class="champs">
                    <!-- <div class="ligne"> -->
                    <div class="nom">{{ $t('_type_modules_') }} (*)</div>
                    <!-- </div> -->
                    <select class="createSelect" v-model="reponse.typeModule.value">
                        <option disabled value=""> </option>
                        <option v-for="(module, index) in modules" :value="module.ref" :key=index>
                            {{ module.ref }}
                        </option>
                    </select>
                </div>
                <div class="groupe">
                    <div class="champs block">
                        <div>
                            {{ $t('_date_d_installation_') }} (*)
                        </div>
                        <div class="input">
                            <input class="date" type="date" v-model="reponse.dateInstall.value" />
                        </div>
                    </div>
                    <div class="champs block">
                        <div>
                            {{ $t('_date_de_fin_d_exloitation_') }}
                        </div>
                        <div class="input">
                            <input class="date" type="date" v-model="reponse.dateFinExploit.value" />
                        </div>
                    </div>
                </div>
                <div v-if="reponse.dateFinExploit.value !== '' && reponse.dateInstall.value !== '' && reponse.dateFinExploit.value < reponse.dateInstall.value"
                    class="warn"> {{ $t('_attention_la_date_de_fin_d_exploit_') }}</div>

                <div class="champs">
                    <div>
                        {{ $t('_commentaire_') }}
                    </div>
                    <div class="input">
                        <v-text-field outlined class="inputField" v-model="reponse.comment.value">
                        </v-text-field>
                    </div>
                </div>
                <v-btn v-if="!edition" :disabled="!rempli"
                    style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw;  font-size: 1rem;"
                    @click="addData()">
                    {{ $t('_ajouter_') }}
                </v-btn>
                <div v-else>
                    <v-btn :disabled="!rempli"
                        style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                        @click="editData()">
                        {{ $t('_modifier_') }}
                    </v-btn>
                    <v-btn
                        style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw; margin-top: 2vh; font-size: 1rem;"
                        @click="cancelEdit()">
                        {{ $t('_annuler_') }}
                    </v-btn>
                </div>
            </v-col>
            <v-col class="tableauCalepinage colsCalepinage" cols="6">
                <div style="display: flex; justify-content: space-between;width: 100%; ">
                    <div style="height: fit-content; align-self: center;">
                        {{ $t("_dupliquer_le_chargement_d_un_onduleur_") }}
                    </div>
                    <div style="width: 15%;">
                        <div>{{ $t("_depuis_") }}:</div>
                        <select class="createSelect" v-model="invADupliquer">
                            <option disabled value=""> </option>
                            <option v-for="inv in getListInv()" :value="inv" :key=inv>
                                {{ findNameFromId(inv) }}
                            </option>
                        </select>
                    </div>
                    <div style="width: 15%;">
                        <div>{{ $t("_vers_") }}: </div>
                        <select :disabled="invADupliquer === ''" class="createSelect" v-model="invDestDuplicage">
                            <option disabled value=""> </option>
                            <option v-for="inv in getSameMPPT()" :value="inv" :key=inv>
                                {{ findNameFromId(inv) }}
                            </option>
                        </select>
                    </div>

                    <v-btn :disabled="invADupliquer === '' || invDestDuplicage === ''"
                        style="float: right; background-color: #d9d9d9; padding: 1vh; margin-right: 1vw;  font-size: 1rem; align-self: center;"
                        @click="duplicateData()">
                        {{ $t('_dupliquer_') }}
                    </v-btn>

                </div>
                <v-data-table class="calepinageTable" :item-class="getRowClass" :items="calepinage"
                    :headers="headerCalepinage" :items-per-page="-1" @click:row="editItem" fixed-header
                    hide-default-footer>
                    <template v-slot:top>
                        <v-toolbar flat style="background-color:#F2F4F4">
                            <v-toolbar-title>{{ $t('_calepinage_') }}</v-toolbar-title>
                        </v-toolbar>
                    </template>
                    <template v-slot:item.actions="{ item }">
                        <v-icon small @click.stop="deleteItem(item)">
                            mdi-minus-box
                        </v-icon>
                    </template>
                </v-data-table>

            </v-col>
        </v-row>
    </div>
</template>

<script>

export default {
    props: {
        onduleurs: {
            required: true,
        },
        historiqueOnduleurs: {
            required: true,
        },
        rampants: {
            required: true,
        },
        modules: {
            required: true,
        },
        initCalepinage: {
            required: false
        },
        install_id: {
            required: true
        }
    },

    data() {
        return {
            calepinage: [],
            nbMPPT: 0,
            listeModeleOnduleur: null,
            listeNouveuxOnduleur: null,
            invADupliquer: "",
            invDestDuplicage: "",
            rempli: false,
            edition: false,
            indexEdite: null,
            headerRampants: [
                { key: 'id', text: this.$t('_identifiant_'), value: 'id' },
                { key: 'nomRampant', text: this.$t('_nom_rampant_'), value: 'nomRampant' },
                { key: 'orientationPV', text: this.$t('_orientation_'), value: 'orientationPV' },
                { key: 'inclinaisonPV', text: this.$t('_inclinaison_'), value: 'inclinaisonPV' },
            ],
            headerOnduleurs: [
                { key: 'id', text: this.$t('_identifiant_'), value: 'id' },
                { key: 'nom', text: this.$t('_nom_'), value: 'nom' },
                { key: 'type', text: this.$t('_type_d_onduleur_'), value: 'type' },
                { key: 'dateInstall', text: this.$t('_date_d_installation_'), value: 'dateInstall' },
            ],
            headerCalepinage: [
                { key: 'idOnduleur', text: this.$t('_id_onduleur_'), value: 'idOnduleur' },
                { key: 'nom', text: this.$t('_point_de_mesure_'), value: 'nom' },
                { key: 'idRampant', text: this.$t('_id_rampant_'), value: 'idRampant' },
                { key: 'typeModule', text: this.$t('_type_modules_'), value: 'typeModule' },
                { key: 'nbModule', text: this.$t('_nb_modules_chaine_'), value: 'nbModule' },
                { key: 'nbChaine', text: this.$t('_nb_chaines_en_parallele_'), value: 'nbChaine' },
                { key: 'actions', text: '', value: 'actions', sortable: false },
            ],
            reponse: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "cleMpp":{
                    "value": "",
                    "required": false,
                },
                "nom": {
                    "value": "",
                    "required": false,
                },
                "idOnduleur": {
                    "value": "",
                    "required": true,
                },
                "entreeDC": {
                    "value": "",
                    "required": true,
                },
                "idRampant": {
                    "value": "",
                    "required": true,
                },
                "nbChaine": {
                    "value": "",
                    "required": true,
                },
                "nbModule": {
                    "value": "",
                    "required": true,
                },
                "initNbChaine": {
                    "value": "",
                    "required": false,
                },
                "initNbModule": {
                    "value": "",
                    "required": false,
                },
                "chaineUniforme": {
                    "value": "",
                    "required": true,
                },
                "typeModule": {
                    "value": "",
                    "required": true,
                },
                "dateInstall": {
                    "value": "",
                    "required": true,
                },
                "dateFinExploit": {
                    "value": "",
                    "required": false,
                },
                "comment": {
                    "value": "",
                    "required": false,
                }
            },
            reponseVide: {
                "id": {
                    "value": "",
                    "required": false,
                },
                "cleMpp":{
                    "value": "",
                    "required": false,
                },
                "nom": {
                    "value": "",
                    "required": false,
                },
                "idOnduleur": {
                    "value": "",
                    "required": true,
                },
                "entreeDC": {
                    "value": "",
                    "required": true,
                },
                "idRampant": {
                    "value": "",
                    "required": true,
                },
                "nbChaine": {
                    "value": "",
                    "required": true,
                },
                "nbModule": {
                    "value": "",
                    "required": true,
                },
                "initNbChaine": {
                    "value": "",
                    "required": false,
                },
                "initNbModule": {
                    "value": "",
                    "required": false,
                },
                "chaineUniforme": {
                    "value": "",
                    "required": true,
                },
                "typeModule": {
                    "value": "",
                    "required": true,
                },
                "dateInstall": {
                    "value": "",
                    "required": true,
                },
                "dateFinExploit": {
                    "value": "",
                    "required": false,
                },
                "comment": {
                    "value": "",
                    "required": false,
                }
            }
        }
    },

    //initialise la date d'instalation à la date du jour, et pre rempli le formulaire avec les données deja enregistées
    async mounted() {
        const today = new Date();
        const day = String(today.getDate()).padStart(2, '0');     // Jour (2 chiffres)
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Mois (2 chiffres, attention +1)
        const year = today.getFullYear();
        this.reponse.dateInstall.value = `${year}-${month}-${day}`
        this.reponseVide.dateInstall.value=`${year}-${month}-${day}`
        if (this.initCalepinage !== undefined && this.initCalepinage !== null) {
            this.calepinage = this.initCalepinage
        }

      
    },

    methods: {
        //ecupere le nom des onduleurs selon leur id
        findNameFromId(id) {
            let name = ""
            this.historiqueOnduleurs.forEach((inv) => {
                if (inv.id === id)
                    name = inv.nom
            })
            return name
        },

        //trouve le nombre de mppt de chaqu onduleur (pour savoir combien mettre d'entrées dc)
        findNbMPPT() {
            let idOnduleur = this.reponse.idOnduleur.value
            if (idOnduleur !== "") {
                let modeleOnduleur
                let nb = null
                this.historiqueOnduleurs.forEach(i => {
                    if (i.id === idOnduleur)
                        modeleOnduleur = i.type
                })
                this.onduleurs.forEach(inv => {
                    if (inv.modele === modeleOnduleur) {
                        nb = Number(inv.nb_mppt)
                    }
                })

                return nb
            }
        },
        getListInv() {
            let liste = []
            this.calepinage.forEach(calp => {
                if (liste.indexOf(calp.idOnduleur) === -1)
                    liste.push(calp.idOnduleur)
            })
            return liste
        },
        //Touve la liste des onduleurs qui ont le meme mppt de l'onduleur a dupliquer
        getSameMPPT() {
            let liste = []
            let nbMPPT = this.getNbMPPTById(this.invADupliquer)
            this.historiqueOnduleurs.forEach(inv => {
                if (this.getNbMPPTById(inv.id) === nbMPPT && inv.id !== this.invADupliquer) {
                    liste.push(inv.id)
                }
            })
            return liste

        },
        getNbMPPTById(id) {
            let nbMPPT = 0
            let modeleOnduleur
            this.historiqueOnduleurs.forEach(i => {
                if (i.id === id)
                    modeleOnduleur = i.type
            })
            this.onduleurs.forEach(inv => {
                if (inv.modele === modeleOnduleur) {
                    nbMPPT = Number(inv.nb_mppt)
                }
            })
            return nbMPPT
        },
        //Dupplique le chargement d'un onduleur vers un autre
        async duplicateData() {
            for (let calp of this.calepinage) {
                if (calp.idOnduleur === this.invADupliquer) {
                    this.reponse.idOnduleur.value = this.invDestDuplicage;
                    this.reponse.entreeDC.value = this.findNameFromId(this.invDestDuplicage) + "." + calp.entreeDC.split(".")[1];

                    for (let champs in this.reponse) {
                        if (champs !== "cleMpp" && champs !== "nom" && champs !== "idOnduleur" && champs !== "entreeDC") {
                            this.reponse[champs].value = calp[champs];
                        }
                    }

                    await this.$nextTick();
                    await this.addData();
                }
            }
            this.invADupliquer = ""
            this.invDestDuplicage = ""
        },
        editItem(item) {
            this.edition = true
            this.indexEdite = this.calepinage.indexOf(item)
            for (var champ in item) {
                this.reponse[champ].value = item[champ]
            }

        },

        cancelEdit() {
            this.edition = false
            this.indexEdite = null
            this.$nextTick(() => {
                for (var champ in this.reponseVide) {
                    this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                }

            })
        },

        getRowClass(item) {
            return this.indexEdite === this.calepinage.indexOf(item) ? 'lineEdit' : '';
        },

        editData() {
            if (this.reponse.nom.value === this.reponseVide.nom.value)
                this.reponse.nom.value = this.reponse.entreeDC.value
            for (var champ in this.reponse) {
                this.calepinage[this.indexEdite][champ] = this.reponse[champ].value
            }
            this.calepinage[this.indexEdite].cleMpp=this.reponse.idOnduleur.value + "-" + this.reponse.entreeDC.value.split(".")[1]
            this.edition = false
            this.indexEdite = null
            this.$nextTick(() => {
                for (var champ in this.reponseVide) {
                    this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                }

            })
        },
        addData() {
            if (this.rempli) {
                this.reponse.id.value=this.calepinage.length+1
                this.reponse.cleMpp.value = this.reponse.idOnduleur.value + "-" + this.reponse.entreeDC.value.split(".")[1]
                if (this.reponse.nom.value === this.reponseVide.nom.value)
                    this.reponse.nom.value = this.reponse.entreeDC.value
                var justeValeurs = {}
                for (var champ in this.reponse) {
                    justeValeurs[champ] = this.reponse[champ].value
                }
                this.calepinage.push(justeValeurs)
                this.$nextTick(() => {
                    for (var champ in this.reponseVide) {
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }

                })
            }
        },
        deleteItem(item) {
            this.calepinage.splice(this.calepinage.indexOf(item), 1)
            this.$nextTick(() => {
                for (var i = 0; i < this.calepinage.length; i += 1) {
                    this.calepinage[i].id = i + 1
                }
            })
            if (this.edition === true) {
                this.edition = false
                this.indexEdite = null
                this.$nextTick(() => {
                    for (var champ in this.reponseVide) {
                        this.reponse[champ] = Object.assign({}, this.reponseVide[champ])
                    }

                })
            }
        },
    },
    watch: {
        reponse: {
            //a chaque modification de la reponse on regarde si elle est complete et on envoie les reponse a PopupCreation.vue  
            handler() {
                let nouveauRempli = true
                for (var champs in this.reponse) {
                    if (this.reponse[champs].required === true && this.reponse[champs].value === "") {
                        nouveauRempli = false
                    }
                }
                if (this.reponse["dateFinExploit"].value !== '' && this.reponse["dateInstall"].value !== '' && this.reponse["dateInstall"].value > this.reponse["dateFinExploit"].value) {
                    nouveauRempli = false
                }
                this.rempli = nouveauRempli

                this.$emit("answer", this.calepinage)
            },
            deep: true
        },
        calepinage: {
            //si il y a plus de un mpp renseigné dans le calepinage, le bouton suivant est activé
            handler() {
                if (this.calepinage.length > 0) {
                    this.$emit('enable')
                }
                else {
                    this.$emit('disable')
                }
            },
            deep: true
        },
        
        initCalepinage: {
            handler() {
                if (this.initCalepinage !== undefined && this.initCalepinage !== null)
                    this.calepinage = this.initCalepinage
            }, deep: true
        }
    }
}

</script>

<style scoped>
.ligne {
    font-weight: bolder;
}

.tableauCalepinage {
    display: flex;
    flex-wrap: wrap;
    gap: 2%;
    height: 100%;
    width: 100%;
}

.tableauCalepinage .theme--light.v-data-table {
    border: 1px solid;
    border-color: rgba(47, 47, 47, 0.5);
    border-radius: 5px;
}

.tableauCalepinage .theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: unset;
}

.calepinageTable {
    height: 60vh;
    max-height: 90%;
    overflow-y: auto;
}

.calepinageTable>>>.lineEdit {
    background-color: #d9d9d9;
}

.tableCalepinage {
    height: 30vh;
    max-height: 48%;
    width: 100%;
    overflow-y: auto;
    display: block;
}


.block {
    display: table-column;
    width: 50%;
}

.groupe {
    display: flex;
    flex-wrap: nowrap;
    gap: 10px;
    align-items: flex-end;
    width: 100%;
}

.colsCalepinage {
    padding-top: 0px;
    padding-left: 6px;
    padding-right: 6px;
}
</style>